export interface IServiceAdminUserAuthorizationConfig {
    isManageMyProfile: string
    isManageBranchProfile: string
    isManageBranchUsers: string
}

export const ServiceAdminUserManagementPrevilages = () => {
    const ServiceAdmin: IServiceAdminUserAuthorizationConfig = {
        isManageMyProfile: 'Enabled',
        isManageBranchProfile: 'Enabled',
        isManageBranchUsers: 'Enabled'
    }

    const adminHashMap = new Map<string, IServiceAdminUserAuthorizationConfig>()
    adminHashMap.set('ServiceAdminUserManagement', ServiceAdmin)

    return adminHashMap
}

export const defaultServiceAdminUserManagement: IServiceAdminUserAuthorizationConfig = {
    isManageMyProfile: 'Disabled',
    isManageBranchProfile: 'Disabled',
    isManageBranchUsers: 'Disabled'
}
